// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const TEST_URL = "https://bixin.com.pe:8443";
const PROD_URL = "https://bixin.com.pe";

const BASE_URL = PROD_URL;

export const environment = {
  production: false,
  baseUrl: BASE_URL,

  // serviceUrl: "http://localhost:24893/webapiz2h/v1/",
  // serviceImageUrl: "http://localhost/itBankSeguridadApi/webapiz2h/v1/",

  serviceUrl: BASE_URL + "/itBankSeguridadApi/webapiz2h/v1/",
  serviceCreditosUrl: BASE_URL + "/itBankCreditosApi/webapiz2h/v1/",
  serviceImageUrl: BASE_URL + "/itBankFileUploadApi/webapiz2h/v1/fileupload/",
  userDefault: "ADMIN",
  versionAngular: "7.0.3",
  versionAppWeb: "v5.6",
  appVersionID: 2,
  aplicacionID: 1,
  pathDocumentos: './assets/images/',

  // compliar:ng build --base-href /itBankSeguridad/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
